import { useEffect } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { LoadingSpinner } from "./Components/LoadingSpinner";

import Home from "./Pages/Home";
import Everify from "./Pages/Everify/Everify";
import CompanyAdmin from "./Pages/CompanyAdmin";
import Login from "./Pages/Auth/Login";
import ProtectedRoute from "./Common/ProtectedRoute";
import { useAuth } from "./context/AuthContext";
import { useCompanySelection } from "./context/CompanySelectionContext";
import TentativeNonConfirmation from "./Pages/StatusPages/TentativeNonConfirmation";
import ConfirmDetailsPage from "./Pages/StatusPages/ConfirmDetailsPage";
import DocumentPhotoVerification from "./Pages/StatusPages/DocumentPhotoVerification";
import PhotoMatchPage from "./Pages/StatusPages/PhotoMatchPage";
import ScanAndUploadPage from "./Pages/StatusPages/ScanAndUploadPage";
import ManualReviewPage from "./Pages/StatusPages/ManualReviewPage";
import PendingReferralPage from "./Pages/StatusPages/PendingReferralPage";
import ReferredPage from "./Pages/StatusPages/ReferredPage";
import QueuedPage from "./Pages/StatusPages/QueuedPage";
import FinalNcPage from "./Pages/StatusPages/FinalNcPage";
import TechnicalIssuePage from "./Pages/StatusPages/TechnicalIssuePage";

const RootRoute = () => {
  const { isAuthenticated, loading } = useAuth();
  const { loading: companyLoading } = useCompanySelection();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated || loading) return;

    const redirectFrom = location.state?.from;
    if (!redirectFrom) return;

    const targetPath = `${redirectFrom.pathname || "/"}${
      redirectFrom.search || ""
    }${redirectFrom.hash || ""}`;

    navigate(targetPath, { replace: true, state: null });
  }, [isAuthenticated, loading, location.state, navigate]);

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  if (companyLoading) {
    return <LoadingSpinner />;
  }

  return <Home />;
};

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<RootRoute />} />
      <Route
        path="/initiateeverify"
        element={
          <ProtectedRoute>
            <Everify />
          </ProtectedRoute>
        }
      />
      <Route
        path="/companyadmin"
        element={
          <ProtectedRoute>
            <CompanyAdmin />
          </ProtectedRoute>
        }
      />
      <Route
        path="/case/tentative-nc"
        element={
          <ProtectedRoute>
            <TentativeNonConfirmation />
          </ProtectedRoute>
        }
      />
      <Route
        path="/case/confirm-details"
        element={
          <ProtectedRoute>
            <ConfirmDetailsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/case/photo-verification"
        element={
          <ProtectedRoute>
            <DocumentPhotoVerification />
          </ProtectedRoute>
        }
      />
      <Route
        path="/case/photo-match"
        element={
          <ProtectedRoute>
            <PhotoMatchPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/case/scan-upload"
        element={
          <ProtectedRoute>
            <ScanAndUploadPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/case/manual-review"
        element={
          <ProtectedRoute>
            <ManualReviewPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/case/pending-referral"
        element={
          <ProtectedRoute>
            <PendingReferralPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/case/referred"
        element={
          <ProtectedRoute>
            <ReferredPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/case/queued"
        element={
          <ProtectedRoute>
            <QueuedPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/case/final-nc"
        element={
          <ProtectedRoute>
            <FinalNcPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/case/technical-issue"
        element={
          <ProtectedRoute>
            <TechnicalIssuePage />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
